var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"size":"full"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('iframe',{staticClass:"frame",attrs:{"frameborder":"0","allowFullScreen":true,"src":_vm.boardUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }